"use strict";

var init = function() {
  document.addEventListener(
    "VIEW_CHANGE",
    function(e) {
      if (e.detail.view === "filters" && window.history.replaceState) {
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search.replace(/[\?&]searchTile=ai/, "").replace(/^&/, "?")
        );
      }
    },
    false
  );
};

module.exports = {
  init: init
};
